<script lang="ts" setup>
import FooterIcons from "~/components/Footer/Icons.vue";
import FooterNav from "~/components/Footer/Nav.vue";
import NavbarMenu  from "~/components/Navbar/Menu.vue";


const route = useRoute();
const page: any = await usePage(route.path.toString());

</script>
<template>
    <NavbarMenu :page="page"/>
    <slot />
    <FooterIcons/>
    <FooterNav/>
</template>
